<cx-spinner class="overlay" *ngIf="isUpdating$ | async"></cx-spinner>

<ng-container>
  <section class="container-box box-login">
    <div class="box-info">
      <h2 class="text-center mb-2">Iniciar sesion</h2>
      <form (ngSubmit)="onSubmit()"
       [formGroup]="form"
        [attr.method]="method"
        [attr.action]="action"
        #loginForm
        class="mt-4">
        <div class="mb-2">
          <label for="rut" class="form-label">
            {{ 'loginForm.emailAddress.label' | cxTranslate }}:
          </label>
          <input
            [required]="true"
            type="text"
            class="form-control"
            formControlName="userId"
            name="username"
            mask="AAAAAAA-A||AAAAAAAA-A"
            [dropSpecialCharacters]="false"
            [validation]="false"
            placeholder="{{ 'loginForm.emailAddress.placeholder' | cxTranslate }}"
            [attr.aria-label]="'loginForm.emailAddress.label' | cxTranslate"
            [attr.aria-invalid]="
              form.get('userId')?.touched && form.get('userId')?.invalid
            "
            [attr.aria-errormessage]="'userIdError'"
          />
          <cx-form-errors [control]="form.get('userId')"></cx-form-errors>
        </div>

        <div class="mb-3">
          <label for="password" class="form-label">Contrasena:</label>
          <input
            [required]="true"
            type="password"
            class="form-control"
            placeholder="{{ 'loginForm.password.placeholder' | cxTranslate }}"
            formControlName="password"
            name="password"
            [attr.aria-label]="'loginForm.password.placeholder' | cxTranslate"
            [attr.aria-invalid]="
              form.get('password')?.touched && form.get('password')?.invalid
            "
            [attr.aria-errormessage]="'passwordError'"
            cxPasswordVisibilitySwitch
          />
          <cx-form-errors [control]="form.get('password')"></cx-form-errors>
        </div>

        <button
          type="submit"
          class="btn btn-block btn-primary bt-login"
          [disabled]="form.disabled"
        >
          {{ 'loginForm.signIn' | cxTranslate }}
        </button>

        <ng-container *cxFeature="'authorizationCodeFlowByDefault'">
          <input
            *ngIf="csrf"
            formControlName="csrf"
            type="hidden"
            [name]="csrf.parameterName"
          />
        </ng-container>
      </form>
    </div>
    <div>
      <img
        class="bg-image"
        src="/assets/img/icons/andes-background.png"
        alt="Andes Motor"
      />
    </div>
  </section>
</ng-container>
